/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { QuestionOptionValue } from './questionOptionValue';

export interface QuestionOption {
  id: string;
  label: string;
  value?: QuestionOptionValue;
}
